import React from "react";
import { Button, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress } from "@mui/material";
import {
  completeNightAuditDate,
  getCurrentNightAuditDate,
  updateNightAuditModalDisplay,
} from "../../reducer/appHeaderReducer";
import { TranslateText } from "../../utils/translation";

const NightAuditConfirmationModal = ({ setActiveTab }) => {
  const { nightAuditModalDisplay, nightAuditDateLoading } = useSelector(
    (store) => store.appHeader
  );

  const { hotelDetails } = useSelector((store) => store.login);

  const dispatch = useDispatch();

  const handleOhk = async () => {
    try {
      // Wait for the completion of night audit
      const result = await dispatch(completeNightAuditDate({ hotelId: hotelDetails?.id }));

      // Only continue if the first action was successful
      if (completeNightAuditDate.fulfilled.match(result)) {
        // Now fetch the updated date
        await dispatch(getCurrentNightAuditDate({ hotelId: hotelDetails?.id }));
      } else {
        console.error("Night audit completion failed", result);
      }
    } catch (error) {
      console.error("Error during night audit process:", error);
    }
    dispatch(updateNightAuditModalDisplay(false));

    setActiveTab(3);
  };

  return (
    <Modal
      open={nightAuditModalDisplay}
      centered
      title=""
      mask={true}
      styles={{ mask: { backdropFilter: "blur(2px)" } }}
      width={"450px"}
      onCancel={() => dispatch(updateNightAuditModalDisplay(false))}
      footer={
        <div className="w-full flex gap-2 justify-center mt-5">
          <Button
            className="text-[1.1rem]  w-[11rem] h-[3rem] rounded-[0.5rem] font-body font-[600] text-fg-muted border-brand-border"
            onClick={() => dispatch(updateNightAuditModalDisplay(false))}
          >
            <TranslateText textKey={"no"} namespace="common" />
          </Button>

          {nightAuditDateLoading ? (
            <Button className="text-fg-inverse text-[1.1rem] rounded-[0.5rem]  bg-primary w-[11rem] h-[3rem]">
              <CircularProgress size={24} color="inherit" />
            </Button>
          ) : (
            <Button
              className="text-fg-inverse text-[1.1rem] rounded-[0.5rem]  bg-primary w-[11rem] h-[3rem]"
              onClick={handleOhk}
            >
              <TranslateText textKey={"yes"} namespace="common" />
            </Button>
          )}
        </div>
      }
    >
      <div className="font-heading text-[18px] leading-[28px] font-[600] mb-2 text-fg-secondary">
        <TranslateText textKey={"complete_audit"} namespace="common" />
      </div>
      <div className="text-fg-muted font-body text-[0.875remrem] font-[400] leading-[20px]">
        <TranslateText
          textKey={
            "by_clicking_yes_this_billing_cycle_will_be_closed_and_new_billing_cycle_will_be_started"
          }
          namespace="common"
        />
      </div>
    </Modal>
  );
};

export default NightAuditConfirmationModal;
